import Component from "vue-class-component";
import * as $ from "jquery";
import { TableauDto } from "../../dto/GenApi.iNotPaie.Dto/TableauDto";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import ModalEditionTableau from "./modalEditionTableau/modalEditionTableau";
import ModalUpdateTableau from "./modalUpdateTableau/modalUpdateTableau";
import { EventBus } from "../Controls/EventBus";
import { DemandeEditionTableauDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeEditionTableauDto";
import ModalJournalTableau from "./modalJournalTableau/modalJournalTableau";
import ModalDeclarationCharges from "./modalDeclarationCharges/modalDeclarationCharges";
import ModalVariablesTableau from "./modalVariablesTableau/modalVariablesTableau";
import { ExerciceDto } from "../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import ModalListeSalarie from "./modalListeSalarie/modalListeSalarie";
import { ParametresInstance } from "../Controls/Parameters";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { FeatureFlagManagerInstance } from "../Controls/FeatureFlagManager";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";

@Component({
	components: {
		ModalEditionTableau: require("./modalEditionTableau/modalEditionTableau.vue.html"),
		ModalListeSalarie: require("./modalListeSalarie/modalListeSalarie.vue.html"),
		ModalUpdateTableau: require("./modalUpdateTableau/modalUpdateTableau.vue.html"),
		ModalJournalTableau: require("./modalJournalTableau/modalJournalTableau.vue.html"),
		ModalDeclarationCharges: require("./modalDeclarationCharges/modalDeclarationCharges.vue.html"),
		ModalVariablesTableau: require("./modalVariablesTableau/modalVariablesTableau.vue.html"),
		ModalEditionListeVariables: require("./modalEditionListeVariables/modalEditionListeVariables.vue.html")
	},
	beforeRouteUpdate(to, from, next) {
		next();
		const vm = (this as Tableaux);
		if (to.query.mode == "journal") {
			vm.filterTypeTableau = "J";
			vm.openDefaultJournal = true;
			vm.openDefaultVariables = false;
		} else if (to.query.mode == "variables") {
			vm.filterTypeTableau = "L";
			vm.openDefaultJournal = false;
			vm.openDefaultVariables = true;
		} else {
			vm.filterTypeTableau = "L";
			vm.openDefaultJournal = false;
			vm.openDefaultVariables = false;
		}
		vm.fetchData();
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as Tableaux);
			if (to.query.mode == "journal") {
				vm.filterTypeTableau = "J";
				vm.openDefaultJournal = true;
				vm.openDefaultVariables = false;
			} else if (to.query.mode == "variables") {
				vm.filterTypeTableau = "L";
				vm.openDefaultJournal = false;
				vm.openDefaultVariables = true;
			} else {
				vm.filterTypeTableau = "L";
				vm.openDefaultJournal = false;
				vm.openDefaultVariables = false;
				vm.getClassOfOrder("TitreEdition", true);
			}
			vm.fetchData();
		});
	}
})
export default class Tableaux extends VueBase {
	public filterName = "";
	public currentOrderColumn = "TitreEdition";
	public orderingDesc = true;
	public dataReady = false;
	public tableaux: TableauDto[] = [];
	public tableauxFlitres: TableauDto[] = [];
	public filterTypeTableau = "L";
	public openDefaultJournal = false;
	public openDefaultVariables = false;
	public displayArchives = false;
	public modalDeclarationCharges?: ModalDeclarationCharges = undefined;
	public modalVariablesTableau?: ModalVariablesTableau = undefined;
	public modalJournalTableau?: ModalJournalTableau = undefined;
	public modalUpdateTableau?: ModalUpdateTableau = undefined;
	public modalEditionTableau?: ModalEditionTableau = undefined;
	public estUtilisateurAdministrateur = false;

	public canDoTransfert = false;

	public fetchData(): void {
    	this.dataReady = false;

		this.estUtilisateurAdministrateur = ParametresInstance.userIsAuthorized([RoleConstants.Administrateur, RoleConstants.AdministrateurPST]);

    	ServicesFactoryInstance.EditionsService.getTableaux(data => {
    		this.tableaux = data;
    		this.doFilter();
    		if (this.openDefaultJournal) {
    			this.openDefaultJournal = false;
    			const defaultJournal = this.tableauxFlitres.filter(t => t.FinMois);
    			if (defaultJournal != undefined && defaultJournal.length > 0) {
					this.imprimer(defaultJournal[0]);
				}
    		}

    		if (this.openDefaultVariables) {
    			$("#modalEditionListeVariables").modal("show");
    			this.openDefaultVariables = false;
			}

			this.canDoTransfert = ParametresInstance.userIsCombinedAuthorized(["Administrateur", "AdministrateurPST"])
				&& FeatureFlagManagerInstance.hasFeatureFlag(FeatureFlagModuleEnum.TransfertSql);

			this.dataReady = true;
    	});
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
    	if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "icons";
	}

	public click_check(target: any): void {
    	const element: HTMLElement = document.getElementById(target) as HTMLElement;
    	element.click();
	}

	public doFilter(): void {
		this.tableauxFlitres = this.tableaux.filter(t =>
			this.displayArchives == t.EstArchive &&
			(
				(t.Code && t.Code.toUpperCase().includes(this.filterName.toUpperCase())) ||
				(t.TitreEdition && t.TitreEdition.toUpperCase().includes(this.filterName.toUpperCase())) ||
				(t.NbColonnes && t.NbColonnes.toString().toUpperCase().includes(this.filterName.toUpperCase()))
			) && t.CodeTypeTableau == this.filterTypeTableau
		);

    	this.doOrder();
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;
    	if (this.tableauxFlitres != undefined) {
			this.tableauxFlitres = this.tableauxFlitres.sort((a, b) => {
				// Gestion des valeurs null
				if (a[columnName] === null) {
					return 1;
				}

				if (b[columnName] === null) {
					return -1;
				}

    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	public modify(tableau: TableauDto): void {
    	ServicesFactoryInstance.EditionsService.updateTableau(tableau, () => {
    		NotificationServiceInstance.SendSuccess("La modification du tableau a été prise en compte");
    	});
	}

	public openDeclarationCharges(demande: DemandeEditionTableauDto): void {
    	this.modalDeclarationCharges = this.$refs.modalDeclarationCharges as ModalDeclarationCharges;
    	if (this.modalDeclarationCharges != undefined) {
			this.modalDeclarationCharges.Init(demande);
		}

    	$("#modalDeclarationCharges").modal("show");
	}

	public openListeVariables(exercice: ExerciceDto): void {
    	this.modalVariablesTableau = this.$refs.modalVariablesTableau as ModalVariablesTableau;
    	if (this.modalVariablesTableau != undefined) {
			this.modalVariablesTableau.Init(exercice);
		}

    	$("#modalVariablesTableau").modal("show");
	}

	public openJournal(demande: DemandeEditionTableauDto): void {
    	this.modalJournalTableau = this.$refs.modalJournalTableau as ModalJournalTableau;
    	if (this.modalJournalTableau != undefined) {
			this.modalJournalTableau.Init(demande);
		}

    	$("#modalJournalTableau").modal("show");
	}

	public editTableau(tableau: TableauDto): void {
    	this.modalUpdateTableau = this.$refs.modalUpdateTableau as ModalUpdateTableau;
    	if (this.modalUpdateTableau != undefined) {
			this.modalUpdateTableau.Init(this.filterTypeTableau, tableau.Id);
		}

    	$("#modalUpdateTableau").modal("show");
	}

	public ajouterTableau(): void {
    	this.modalUpdateTableau = this.$refs.modalUpdateTableau as ModalUpdateTableau;
    	if (this.modalUpdateTableau != undefined) {
			this.modalUpdateTableau.Init(this.filterTypeTableau);
		}

    	$("#modalUpdateTableau").modal("show");
	}

	public archiverTableau(id: number): void {
    	const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Souhaitez-vous vraiment archiver ce tableau ?",
    		callBackYes: () => {
    			ServicesFactoryInstance.EditionsService.archiverTableau(id, () => {
    				NotificationServiceInstance.SendSuccess("Tableau archivé avec succès.");
    				this.fetchData();
    			});
    		}
    	});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	public viewListSalarie(demande: any): void {
    	const modalListeSalarie = this.$refs.modalListeSalarie as ModalListeSalarie;
    	if (modalListeSalarie != undefined) {
			modalListeSalarie.initEdition(demande);
		}

    	$("#modalListeSalarie").modal("show");
	}

	public copierTableau(tableau: TableauDto): void {
    	this.modalUpdateTableau = this.$refs.modalUpdateTableau as ModalUpdateTableau;

    	if (this.modalUpdateTableau != undefined) {
			this.modalUpdateTableau.Init(this.filterTypeTableau, tableau.Id, true);
		}

    	$("#modalUpdateTableau").modal("show");
	}

	public imprimer(tableau: TableauDto): void {
    	this.modalEditionTableau = this.$refs.modalEditionTableau as ModalEditionTableau;
    	if (this.modalEditionTableau != undefined) {
			this.modalEditionTableau.Init(tableau);
		}

    	$("#modalEditionTableau").modal("show");
	}

	public openModaleTransfert(tableau: TableauDto): void {
		const modalTransfert: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Cette action va envoyer votre élément vers la liste d'attente des transferts SQL. Souhaitez-vous continuer ?",
			showDialog: true,
			title: "Confirmation",
			callBackYes: () => {
				this.transfertTableau(tableau);
			}
		});

		EventBus.$emit(EventConstants.MODAL_ALERT, modalTransfert);
	}

	public transfertTableau(tableau: TableauDto): void {
		if (this.canDoTransfert && tableau != null) {
			ServicesFactoryInstance.EntiteEnAttenteService.addTableauToList(tableau.Id, () => {
				NotificationServiceInstance.SendSuccess("L'élément <strong>" + tableau.TitreListe + "</strong> a bien été ajouté à la liste d'attente des transferts SQL.");

				this.fetchData();
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/tableaux/tableaux.ts